import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';
import { initializeForm } from '../../../utils/form';
import { validateNotEmpty } from '../../../utils/validators';

$(() => {
    const primaryIntentSection = $('.what-is-primary-intended-purpose');
    const isRequired = primaryIntentSection.find('#intend-purpose-is-mandatory').val();
    const primaryIntentDropdown = primaryIntentSection.find('input[name="primary-intended-purpose"]');
    const primaryIntendedPurposeContainer = primaryIntentSection.find('#primary-intended-purpose-container');

    const primaryIntentForm = initializeForm(primaryIntendedPurposeContainer, {
        preventDefault: true,
        validate: (values) => {
            const errors = {
                ...validateNotEmpty(values, ['primary-intended-purpose'])
            }
            const eventType = isRequired && !$.isEmptyObject(errors) ? ADDITIONAL_DETAILS_EVENTS.ADD_ERROR : ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR;
            EVENT_BUS.dispatch(eventType, {
                error: ADDITIONAL_DETAILS_EVENTS.ERROR.INTENT,
            }); 
        }
    })
});
